import { Button } from "@blueprintjs/core";
import * as React from "react";

import { CheckoutItemDto, StripeApi } from "../../api";
import { useApiService } from "../../hooks";
import { EDrupalRoutes } from "../EDrupalRoutes";

/**
 * Dev-only helper: a discreet floating button that spins up a real Stripe Checkout session with
 * fake data, to test the Stripe flow without needing a billed dossier. Rendered ONLY on localhost
 * so it never ships to a real environment.
 *
 * To exercise the webhook end-to-end, run the Stripe CLI:
 *   stripe listen --forward-to https://localhost:5001/api/Stripe/WebHook --skip-verify
 * and enter the structured communication of a real invoice (otherwise the webhook just logs
 * "invoice not found" and the checkout/redirect part is still validated).
 */
export const StripeTestButton: React.FunctionComponent = () => {
  const stripeApi = useApiService(StripeApi);
  const [loading, setLoading] = React.useState(false);

  const isLocalhost =
    window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  if (!isLocalhost) {
    return null;
  }

  const onClick = async () => {
    const structuredComm = window.prompt(
      "Communication structurée de la facture (laisse la valeur TEST pour un faux paiement non rattaché) :",
      "TEST/00000000/00"
    );
    if (structuredComm === null) {
      return;
    }
    const amountStr = window.prompt("Montant en € :", "1");
    if (amountStr === null) {
      return;
    }
    const amountCents = Math.round(parseFloat(amountStr.replace(",", ".")) * 100);
    if (isNaN(amountCents) || amountCents <= 0) {
      alert("Montant invalide");
      return;
    }

    try {
      setLoading(true);
      const link = await stripeApi.getStripeSessionLink(
        new CheckoutItemDto({
          name: "TEST paiement Stripe",
          price: amountCents,
          quantity: 1,
          invoiceStructuredCommunication: structuredComm,
          previousLocation: window.location.href,
          successUrl: `${window.location.origin}${window.location.pathname}#${EDrupalRoutes.requestList}`,
        })
      );
      window.location.href = link.sessionUrl;
    } catch (e) {
      setLoading(false);
      // eslint-disable-next-line no-console
      console.error("Fake Stripe session error", e);
      alert("Erreur lors de la création de la session Stripe (voir la console / les logs API).");
    }
  };

  return (
    <div style={{ position: "fixed", bottom: 8, right: 8, zIndex: 9999, opacity: 0.65 }}>
      <Button small intent="warning" icon="credit-card" loading={loading} onClick={onClick}>
        DEV: Fake Stripe
      </Button>
    </div>
  );
};
